<!--
  * name: Navigation
  * description: GNB 컴포넌트
-->
<template>
  <!-- 병헌 : 모바일 열리는 네비게이션 -->
  <nav class="nav" :class="mobileClasses">
    <div class="container">
      <div class="row align-items-center nav-main-row">
        <div class="col-6 col-sm-2">
          <a href="" @click.prevent="moveToPageForMobile('/', $event)" class="logo-pc">RIMAN</a>
        </div>
        <div class="col-6 mobile-navi-close-wrap hide-pc">
          <!-- <select class="mobile-navi-lang" name="" id="">
            <option value="">한국어</option>
            <option value="">English</option>
            <option value="">中文</option>
          </select> -->
          <button
            class="btn-close-mNavi"
            @click="toggleMobileMenu"
            type="button"
          >
            닫기
          </button>
        </div>
        <div class="col-sm-10 nav-main" id="GoMainMenu" ref="navig">
          <a href="" :class="menuList.brandstory" @click.prevent="moveToPageForMobile('/brandstory', $event)">BRAND STORY</a>
          <a href="" :class="menuList.products" @click.prevent="moveToPageForMobile('/products', $event)">PRODUCTS</a>
          <a href="" :class="menuList.brandfilm" @click.prevent="moveToPageForMobile('/brandfilm', $event)">BRAND FILM</a>
          <a href="" :class="menuList.news" @click.prevent="moveToPageForMobile('/news', $event)">NEWS</a>
          <a href="" :class="menuList.sns" @click.prevent="moveToPageForMobile('/sns', $event)">SNS</a>
        </div>
      </div>
    </div>
    <div class="mobile-navi-util-wrap hide-pc">
      <account-menu :isPC="false" :show-mobile-menu="showMobileMenu"/>
      <nav class="navi-wrap">
        <div class="unit">
          <div class="head-wrap">
            <h2 class="tit">Customer Support</h2>
          </div>
          <ul class="menu">
            <!-- <li><a href="">사업제휴</a></li> -->
            <li><a :href="`${rimanLink}/faq`" target="_blank">자주묻는질문</a></li>
            <li><a :href="`${rimanLink}/request`" target="_blank">문의하기</a></li>
            <li><a :href="`${rimanLink}/office`" target="_blank">사옥 소개</a></li>
            <li><a :href="`${rimanLink}/cibi`" target="_blank">CI/BI 소개</a></li>
            <li>
              <a class="btn_beautyPlaner_request" href=""
                @click.prevent="openBeautyPlanner">뷰티플래너 조회</a>
              <bp-popup /> <!-- 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 -->
            </li>
            <li><a :href="`${rimanLink}/library`" target="_blank">Library</a></li>
          </ul>
        </div>
        <div class="unit">
          <div class="head-wrap">
            <h2 class="tit">Official Website</h2>
          </div>
          <ul class="menu">
            <li><a :href="rimanLink" target="_blank">RIMAN KOREA</a></li>
            <li><a :href="incelldermLink" target="_blank">INCELLDERM</a></li>
            <li><a :href="botalabLink">botalab</a></li>
            <li><a :href="lifeningLink" target="_blank">Lifening</a></li>
          </ul>
        </div>
        <div class="unit">
          <div class="head-wrap">
            <h2 class="tit">Social Media</h2>
          </div>
          <ul class="menu">
            <li><a href="https://www.youtube.com/channel/UCgFWSkmvaAWcVBaVanKpDYw" target="_blank">RIMAN KOREA Youtube</a></li>
            <li><a href="https://www.instagram.com/incellderm.official" target="_blank">INCELLDERM Instagram</a></li>
            <li><a href="https://www.youtube.com/channel/UChczyeup2UQz4wGpebbMckA"
                target="_blank">INCELLDERM Youtube</a></li>
            <li><a href="https://www.instagram.com/botalab.official"
                target="_blank">botalab Instagram</a></li>
            <li><a href="https://www.youtube.com/channel/UCDfIKM3yZL25ZLdUbWQLVcQ"
                target="_blank">botalab Youtube</a></li>
            <li><a href="https://www.instagram.com/lifening.official" target="_blank">Lifening Instagram</a></li>
            <li><a href="javascript: void(0);" target="_blank">Lifening Youtube</a></li>
          </ul>
        </div>
        <div class="unit">
          <div class="head-wrap">
            <h2 class="tit">Privacy &amp; Terms</h2>
          </div>
          <ul class="menu">
            <li><a :href="`${rimanLink}/agreement/tos`" target="_blank">이용약관</a></li>
            <li><a :href="`${rimanLink}/agreement/privacypolicy`" target="_blank">개인정보처리방침</a></li>

          </ul>
        </div>
      </nav>
    </div>
  </nav>
  <!-- /병헌 : 모바일 열리는 네비게이션 -->
</template>

<script>
import commonUtils from '@/utils/common';
import AccountMenu from './AccountMenu.vue';
import BpPopup from '@/components/footer/BpPopup.vue'; /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */

export default {
  name: 'Navigation',
  props: {
    showMobileMenu: { // 모바일 메뉴 오픈 여부 flag
      type: Boolean,
      required: true,
    },
  },
  components: {
    AccountMenu,
    BpPopup, /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */
  },
  computed: {
    mobileClasses() {
      return {
        open: this.showMobileMenu,

      };
    },
  },
  data() {
    return {
      incelldermLink: `${process.env.VUE_APP_INCELLDERM_URL}`,
      botalabLink: `${process.env.VUE_APP_BOTALAB_URL}`,
      rimanLink: `${process.env.VUE_APP_RIMAN_URL}`,
      lifeningLink: `${process.env.VUE_APP_LIFENING_URL}`,
      menuList: {
        brandstory: '',
        products: '',
        brandfilm: '',
        news: '',
        sns: '',
      },
    };
  },
  watch: {
    '$route.path': function setActive(path) {
      this.menuList.brandstory = '';
      this.menuList.products = '';
      this.menuList.brandfilm = '';
      this.menuList.news = '';
      this.menuList.sns = '';
      const firstPath = path.split('/')[1];
      this.menuList[firstPath] = 'active';
    },
  },
  methods: {
    // ## 모바일 메뉴 Show/Hide 처리 메소드
    toggleMobileMenu() {
      this.$emit('toggle-mobile-menu', !this.showMobileMenu);
    },
    // ## 모바일 메뉴 이동처리 메소드
    // moveToPageForMobile(path, event) {
    //   if (event) {
    //     // event.target.parentElement.children.forEach((item) => {
    //     this.$refs.navig.children.forEach((item) => {
    //       item.classList.remove('active');
    //     });
    //     event.target.classList.add('active');
    //   }
    //   if (this.showMobileMenu) {
    //     this.toggleMobileMenu();
    //   }
    //   this.$router.push(path);
    // },
    moveToPageForMobile(path) {
      if (this.showMobileMenu) {
        this.toggleMobileMenu();
      }
      this.$router.push(path);
    },
    // ## 뷰티플래너 호출 메소드
    openBeautyPlanner() {
      this.$emit('openBpPopup', 'bpPopup'); /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 변경 */
    },
  },
};
</script>

<style></style>
